module.exports = __webpack_public_path__ + "static/nbody-ea15869bb2f2b0f3bfd822d968ee4028.png";